module.exports = __webpack_public_path__ + "static/media/icon-logo.b5d17466.png";